import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './tumorMarker.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class TumorMarkerDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      this.props.tumorMarker.isNullMessageHolder === false ?
      <div className="row item-row"
        data-qa={'tumorMarker_' + this.props.tumorMarker.testType}
      >
        <div className="col-md-4 primary-data">
          {
            this.props.tumorMarker.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.tumorMarker.testType}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.tumorMarkerDate} />}
                value={this.props.tumorMarker.tumorMarkerDate} language={this.props.language} isDate
                isActive={this.configurationActive('TumorMarkerDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.testResult} />}
                value={this.props.tumorMarker.testResult} language={this.props.language}
                isActive={this.configurationActive('TestResult')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerName} />}
                value={this.props.tumorMarker.providerName} language={this.props.language}
                isActive={this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.tumorMarker.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.tumorMarker.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.tumorMarker.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.tumorMarker.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="tumorMarker_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.tumorMarker.nullMessage}
        </div>
      </div>
    );
  }
}

TumorMarkerDetail.propTypes = {
  tumorMarker: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
